<template>
  <div class="bgGra">
    <div class="v-header">
      <div class="carouse_container">
        <CarouselWrap></CarouselWrap>
      </div>
      <div>
        <img alt="" class="img-box" src="@/assets/images/index_1.jpg" style="margin-top: -4px;">
        <img alt="" class="img-box" src="@/assets/images/index_2.jpg" style="transform: translateY(-5px);">
        <img alt="" class="img-box" src="@/assets/images/index_3.jpg" style="transform: translateY(-10px);">
        <img alt="" class="img-box" src="@/assets/images/index_4.jpg" style="transform: translateY(-15px);">
      </div>
    </div>
  </div>
</template>

<script>
import CarouselWrap from '@/views/components/CarouselWrap.vue';

export default {
  components: {
    CarouselWrap
  }
};
</script>
<style lang="less" scoped>
@import url("./style.less");

.carouse_container {
  width: 100%;
  height: 500px;
}

.img-box {
  width: 100%;
}


</style>
